// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".obscure-best-photo[data-v-257ab6eb]{align-items:center;background-color:#212121;color:#fff;display:flex;height:300px;justify-content:center;width:100%}.flex-avatar[data-v-257ab6eb]{flex:0 0!important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
